import { useEffect, useState, useRef, useCallback } from "react";
import Templates from "../../components/Sidebars/Templates";
import Layers from "../../components/Sidebars/Layers";
import layersHide from "../../assets/icons/sidebar-hide.svg";
import "./WorkbenchLeftSidebar.css";

const WorkbenchLeftSidebar = () => {
  const [templatesHeight, setTemplatesHeight] = useState(0); 
  const [isResizing, setIsResizing] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const sidebarRef = useRef<any>(null);
  const startYRef = useRef(0);
  const startHeightRef = useRef(0);

  useEffect(() => {
    const calculateInitialHeight = () => {
      if (sidebarRef.current) {
        const sidebarHeight = sidebarRef.current.offsetHeight;
        const halfHeight = (sidebarHeight - 15) / 2; // Subtract resize handle height
        setTemplatesHeight(halfHeight);
      }
    };

    // Calculate on mount and window resize
    calculateInitialHeight();
    window.addEventListener('resize', calculateInitialHeight);
    
    return () => {
      window.removeEventListener('resize', calculateInitialHeight);
    };
  }, []);
  
  const handleResizeStart = (e: React.MouseEvent) => {
    e.preventDefault();
    startYRef.current = e.clientY;
    startHeightRef.current = templatesHeight;
    setIsResizing(true);
  };

  const handleResizeMove = useCallback((e: MouseEvent) => {
    const delta = e.clientY - startYRef.current;
    const newTemplatesHeight = Math.max(50, startHeightRef.current + delta);

    const sidebarHeight =
      sidebarRef.current?.offsetHeight || window.innerHeight - 70;
    const maxTemplatesHeight = sidebarHeight - 50;

    setTemplatesHeight(Math.min(newTemplatesHeight, maxTemplatesHeight));
  }, []);

  const handleResizeEnd = useCallback(() => {
    setIsResizing(false);
  }, []);

  useEffect(() => {
    if (isResizing) {
      document.addEventListener("mousemove", handleResizeMove);
      document.addEventListener("mouseup", handleResizeEnd);
    } else {
      document.removeEventListener("mousemove", handleResizeMove);
      document.removeEventListener("mouseup", handleResizeEnd);
    }

    return () => {
      document.removeEventListener("mousemove", handleResizeMove);
      document.removeEventListener("mouseup", handleResizeEnd);
    };
  }, [isResizing, handleResizeMove, handleResizeEnd]);

  // useEffect(() => {
  //   return () => {
  //     // Clear session state on unmount
  //     sessionStorage.removeItem("secret_key");
  //     sessionStorage.removeItem("flow_type");
  //   };
  // }, []);

  const handleLayersOpenClose = useCallback(() => {
    setIsCollapsed(!isCollapsed);
  }, [isCollapsed]);

  return (
    <div className="sidebar-container">
      <div
        className={`workbench-left-sidebar ${isCollapsed ? "collapsed" : ""}`}
        ref={sidebarRef}
        style={{
          transform: isCollapsed ? "translateX(-100%)" : "translateX(0)",
          pointerEvents: isCollapsed ? "none" : "auto",
        }}
      >
        <div
          className="workbench-section"
          style={{
            height: `${templatesHeight}px`,
            transition: isResizing ? "none" : "height 0.1s ease",
            scrollbarWidth: "none",
          }}
        >
          <Templates />
        </div>

        <div className="resize-handle" onMouseDown={handleResizeStart}>
          <div className="resize-handle-dots">
            <div className="resize-dot" />
            <div className="resize-dot" />
            <div className="resize-dot" />
          </div>
        </div>

        <div
          className="workbench-section"
          style={{
            height: `calc(100% - ${templatesHeight}px - 15px)`,
            transition: isResizing ? "none" : "height 0.1s ease",
            scrollbarWidth: "none",
          }}
        >
          <Layers />
        </div>
      </div>

      <button
        type="button"
        className={`collapse-button ${isCollapsed ? "collapsed" : ""}`}
        onClick={handleLayersOpenClose}
      >
        <img width={28} src={layersHide} alt="layers toggle" />
      </button>
    </div>
  );
};

export default WorkbenchLeftSidebar;
